import { EOrderStage } from '@/components/pages/ChangeInstallDates/utils/propTypeHelpers'

import { DetailsListCard, DetailsListCardProps } from '../DetailsListCard'
import { DetailsListItems } from '../DetailsList'

import type { OrderDetail } from '@/api/schemas'

export type InstallBookingCardData = {
  installationDate?: string
  installMethod?: string
  contactName?: string
  contactPhoneNumber?: string
}

export type InstallBookingCardProps = Pick<DetailsListCardProps, 'marginBottom'> & {
  data: InstallBookingCardData
  orderData?: OrderDetail
  visitType?: EOrderStage.PRE_WORK | EOrderStage.IN_HOME
}

const contentInstallDate = 'Installation date'
const contentInstallMethod = 'Install method'

const InstallBookingCard = ({ data, marginBottom, orderData, visitType }: InstallBookingCardProps) => {
  const items: DetailsListItems = []

  if (data.installationDate) {
    items.push({
      label: contentInstallDate,
      value: data.installationDate,
    })
  }

  if (data.installMethod) {
    items.push({
      type: 'alert',
      label: contentInstallMethod,
      value: data.installMethod,
      alertVariant: 'info',
    })
  }

  return (
    <DetailsListCard
      backgroundColor="white"
      items={items}
      marginBottom={marginBottom}
      orderData={orderData}
      separatorColour="alto"
      visitType={visitType}
    />
  )
}

export default InstallBookingCard
